import controller from './related-posts.controller';
import template from './templates/related-posts.view.html';
import templateT13 from './templates/related-posts-t13.view.html';
import templateAD from './templates/related-posts-adaptative.view.html';

let RelatedPostsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        categories: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

// function changeTemplate() {
//     if (__env.adaptative) {
//         return templateAD;
//     } else {
//         return template;
//     }
// }

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) { return templateAD; }
    else{
        if(response.RELATED_POSTS.component == 'template_t1'){return template}
        if(response.RELATED_POSTS.component == 'template_t13'){return templateT13}
        else {return templateBase;}
    }
}

export default RelatedPostsComponent;


// WEBPACK FOOTER //
// ./www/components/blog/related-posts/related-posts.component.js